import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Title', prop: 'title' },
  { title: 'Excerpt', prop: 'excerpt' },
  { title: 'Week #', prop: 'week.number', sortable: false },
  { title: 'Program', prop: 'program.name', sortable: false },
  { title: 'Session', prop: 'session.name', sortable: false },
  { title: 'Created', prop: 'created_at', format: 'date' },
  { title: 'Updated', prop: 'updated_at', format: 'date' }
]

const filters = [
  { name: 'Filter by title', prop: 'filters.title_ilike', type: 'text', enabled: true },
  { name: 'Filter by program', prop: 'filters.program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name', displayProp: 'name', enabled: true },
  { name: 'Filter by session', prop: 'filters.session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [
    { column: 'updated_at', direction: 'desc' }
  ]
}

const Topics = (props) => (
  <List
    title='Forum Topics'
    apiPath='admin/topics'
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
  />
)

export default Topics
